module.exports = __webpack_public_path__ + "img/etb_fiatrail.ee9ebac.png";